/**
 * FinanciarTab - Modul Financiar
 * Conține tab-uri: Adaptare | Popriri
 */
import { useState, memo } from 'react';
import AdaptareTab from './AdaptareTab';
import PopririTab from './PopririTab';
import CosturiPersonalTab from './CosturiPersonalTab';
import { FileText, Gavel, Users } from 'lucide-react';

const TABS = [
  { id: 'costuri', label: 'Costuri Personal', icon: Users },
  { id: 'adaptare', label: 'Adaptare', icon: FileText },
  { id: 'popriri', label: 'Popriri', icon: Gavel },
];

const FinanciarTab = memo(function FinanciarTab({ token }) {
  const [activeTab, setActiveTab] = useState('costuri');

  return (
    <div className="space-y-4">
      <div className="flex border-b overflow-x-auto">
        {TABS.map(tab => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium border-b-2 whitespace-nowrap transition-colors ${
                activeTab === tab.id ? 'border-blue-600 text-blue-600' : 'border-transparent text-slate-500 hover:text-slate-700'
              }`}
              data-testid={`financiar-tab-${tab.id}`}
            >
              <Icon className="w-4 h-4" />{tab.label}
            </button>
          );
        })}
      </div>

      {activeTab === 'adaptare' && <AdaptareTab token={token} />}
      {activeTab === 'costuri' && <CosturiPersonalTab token={token} />}
      {activeTab === 'popriri' && <PopririTab token={token} />}
    </div>
  );
});

export default FinanciarTab;
